// - Import react components
import { provider } from 'src/socialEngine';
import { Map } from 'immutable';
// - Import action types
import { UserActionType } from 'constants/userActionType';
// - Import actions
import * as globalActions from 'store/actions/globalActions';
import { SocialProviderTypes } from 'src/core/socialProviderTypes';
/**
 * Get service providers
 */
var userService = provider.get(SocialProviderTypes.UserService);
/* _____________ CRUD DB _____________ */
/**
 * Get user info from database
 */
export var dbGetUserInfo2 = function () {
    return function (dispatch, getState) {
        var state = getState();
        var uid = state.getIn(['authorize', 'uid']);
        if (uid) {
            return userService.getUserProfile(uid).then(function (userProfile) {
                dispatch(addUserInfo(uid, {
                    avatar: userProfile.avatar,
                    email: userProfile.email,
                    firstTime: userProfile.firstTime,
                    fullName: userProfile.fullName,
                    banner: userProfile.banner,
                    tagLine: userProfile.tagLine,
                    creationDate: userProfile.creationDate,
                    birthday: userProfile.birthday,
                    companyName: userProfile.companyName,
                    webUrl: userProfile.webUrl,
                    twitterId: userProfile.twitterId,
                    DefaultSize: userProfile.DefaultSize,
                    ShippingAddress: userProfile.ShippingAddress,
                    HTVerified: userProfile.HTVerified,
                    isDesigner: userProfile.isDesigner,
                    userName: userProfile.userName,
                    merchant_Id: userProfile.merchant_Id,
                    city: userProfile.city,
                    zip: userProfile.zip
                }));
            })
                .catch(function (error) { return dispatch(globalActions.showMessage(error.message)); });
        }
    };
};
export var dbGetUserInfo = function () {
    return function (dispatch, getState) {
        var state = getState();
        var uid = state.getIn(['authorize', 'uid']);
        if (uid) {
            return userService.getUserProfile(uid).then(function (userProfile) {
                dispatch(addUserInfo(uid, {
                    avatar: userProfile.avatar,
                    email: userProfile.email,
                    firstTime: userProfile.firstTime,
                    fullName: userProfile.fullName,
                    banner: userProfile.banner,
                    tagLine: userProfile.tagLine,
                    creationDate: userProfile.creationDate,
                    birthday: userProfile.birthday,
                    companyName: userProfile.companyName,
                    webUrl: userProfile.webUrl,
                    twitterId: userProfile.twitterId,
                    DefaultSize: userProfile.DefaultSize,
                    ShippingAddress: userProfile.ShippingAddress,
                    HTVerified: userProfile.HTVerified,
                    isDesigner: userProfile.isDesigner,
                    userName: userProfile.userName,
                    merchant_Id: userProfile.merchant_Id,
                    city: userProfile.city,
                    zip: userProfile.zip
                }));
            })
                .catch(function (error) { return dispatch(globalActions.showMessage(error.message)); });
        }
    };
};
/**
 *  Get user info from database
 */
export var dbGetUserInfoByUserId = function (uid, callerKey) {
    return function (dispatch, getState) {
        if (uid) {
            var state = getState();
            var caller = state.getIn(['global', 'temp', 'caller']);
            if (caller && caller.indexOf("dbGetUserInfoByUserId-" + uid) > -1) {
                return undefined;
            }
            dispatch(globalActions.temp({ caller: "dbGetUserInfoByUserId-" + uid }));
            return userService.getUserProfile(uid).then(function (userProfile) {
                dispatch(addUserInfo(uid, {
                    avatar: userProfile.avatar,
                    email: userProfile.email,
                    fullName: userProfile.fullName,
                    banner: userProfile.banner,
                    tagLine: userProfile.tagLine,
                    creationDate: userProfile.creationDate,
                    firstTime: userProfile.firstTime,
                    birthday: userProfile.birthday,
                    companyName: userProfile.companyName,
                    webUrl: userProfile.webUrl,
                    twitterId: userProfile.twitterId,
                    DefaultSize: userProfile.DefaultSize,
                    ShippingAddress: userProfile.ShippingAddress,
                    HTVerified: userProfile.HTVerified,
                    isDesigner: userProfile.isDesigner,
                    userName: userProfile.userName,
                    merchant_Id: userProfile.merchant_Id,
                    city: userProfile.city,
                    zip: userProfile.zip
                }));
                switch (callerKey) {
                    case 'header':
                        dispatch(globalActions.setHeaderTitle(userProfile.fullName));
                        break;
                    default:
                        break;
                }
            })
                .catch(function (error) { return dispatch(globalActions.showMessage(error.message)); });
        }
    };
};
export var dbGetUserInfoByUserId2 = function (uid, callerKey) {
    return function (dispatch, getState) {
        if (uid) {
            var state = getState();
            var caller = state.getIn(['global', 'temp', 'caller']);
            if (caller && caller.indexOf("dbGetUserInfoByUserId-" + uid) > -1) {
                return undefined;
            }
            dispatch(globalActions.temp({ caller: "dbGetUserInfoByUserId-" + uid }));
            return userService.getUserProfile2(uid).then(function (userProfile) {
                dispatch(addUserInfo(uid, {
                    avatar: userProfile.avatar,
                    email: userProfile.email,
                    fullName: userProfile.fullName,
                    banner: userProfile.banner,
                    tagLine: userProfile.tagLine,
                    creationDate: userProfile.creationDate,
                    firstTime: userProfile.firstTime,
                    birthday: userProfile.birthday,
                    companyName: userProfile.companyName,
                    webUrl: userProfile.webUrl,
                    twitterId: userProfile.twitterId,
                    DefaultSize: userProfile.DefaultSize,
                    ShippingAddress: userProfile.ShippingAddress,
                    HTVerified: userProfile.HTVerified,
                    isDesigner: userProfile.isDesigner,
                    userName: userProfile.userName,
                    merchant_Id: userProfile.merchant_Id,
                    city: userProfile.city,
                    zip: userProfile.zip
                }));
                switch (callerKey) {
                    case 'header':
                        dispatch(globalActions.setHeaderTitle(userProfile.fullName));
                        break;
                    default:
                        break;
                }
            })
                .catch(function (error) { return dispatch(globalActions.showMessage(error.message)); });
        }
    };
};
/**
 * Updata user information
 * @param {object} newInfo
 */
export var dbUpdateUserInfo = function (newProfile) {
    return function (dispatch, getState) {
        var state = getState();
        var uid = state.getIn(['authorize', 'uid']);
        var profile = state.getIn(['user', 'info', uid]);
        var updatedProfile = {
            avatar: newProfile.avatar || profile.avatar || '',
            banner: newProfile.banner || profile.banner || 'https://firebasestorage.googleapis.com/v0/b/dcomptest-19523.appspot.com/o/defaultBack%2Frain.jpg?alt=media&token=677e6163-db36-45cc-bee6-910cf0a1633a',
            email: newProfile.email || profile.email || '',
            fullName: newProfile.fullName || profile.fullName || '',
            tagLine: newProfile.tagLine || profile.tagLine || '',
            birthday: newProfile.birthday,
            firstTime: newProfile.firstTime,
            companyName: newProfile.companyName || '',
            webUrl: newProfile.webUrl || '',
            twitterId: newProfile.twitterId || '',
            creationDate: newProfile.creationDate,
            DefaultSize: newProfile.DefaultSize || '',
            ShippingAddress: newProfile.ShippingAddress || '',
            HTVerified: newProfile.HTVerified || false,
            isDesigner: newProfile.isDesigner || false,
            userName: newProfile.userName,
            city: newProfile.city || '',
            zip: newProfile.zip || '',
            merchant_Id: newProfile.merchant_Id || ''
            // Address : newProfile.Address || '',
            // Location : newProfile.Location || '',
            // isDesigner: false
        };
        return userService.updateUserProfile(uid, updatedProfile).then(function () {
            dispatch(updateUserInfo(uid, updatedProfile));
            dispatch(closeEditProfile());
        })
            .catch(function (error) { return dispatch(globalActions.showMessage(error.message)); });
    };
};
// - Get people info from database
export var dbGetPeopleInfo = function (page, limit) {
    return function (dispatch, getState) {
        var state = getState();
        var people = state.getIn(['user', 'people']);
        var lastPageRequest = people.get('lastPageRequest');
        var lastUserId = people.get('lastUserId');
        var uid = state.getIn(['authorize', 'uid']);
        if (uid && lastPageRequest !== page) {
            return userService.getUsersProfile(uid, lastUserId, page, limit).then(function (result) {
                if (!result.users || !(result.users.length > 0)) {
                    return dispatch(notMoreDataPeople());
                }
                // Store last user Id
                dispatch(lastUserPeople(result.newLastUserId));
                var parsedData = Map({});
                result.users.forEach(function (user) {
                    var userId = Object.keys(user)[0];
                    var userData = user[userId];
                    parsedData = parsedData.set(userId, userData);
                });
                dispatch(addPeopleInfo(parsedData));
            })
                .catch(function (error) { return dispatch(globalActions.showMessage(error.message)); });
        }
    };
};
/* _____________ CRUD State _____________ */
/**
 * Add user information
 */
export var addUserInfo = function (uid, info) {
    return {
        type: UserActionType.ADD_USER_INFO,
        payload: { uid: uid, info: info }
    };
};
/**
 * Add people information
 */
export var addPeopleInfo = function (infoList) {
    return {
        type: UserActionType.ADD_PEOPLE_INFO,
        payload: infoList
    };
};
/**
 * Update user information
 */
export var updateUserInfo = function (uid, info) {
    return {
        type: UserActionType.UPDATE_USER_INFO,
        payload: { uid: uid, info: info }
    };
};
export var clearAllData = function () {
    return {
        type: UserActionType.CLEAR_ALL_DATA_USER
    };
};
/**
 * Open edit profile
 */
export var openEditProfile = function () {
    return {
        type: UserActionType.OPEN_EDIT_PROFILE
    };
};
/**
 * Close edit profile
 */
export var closeEditProfile = function () {
    return {
        type: UserActionType.CLOSE_EDIT_PROFILE
    };
};
/**
 * Set profile posts has more data to show
 */
export var hasMoreDataPeople = function () {
    return {
        type: UserActionType.HAS_MORE_DATA_PEOPLE
    };
};
/**
 * Set profile posts has not data any more to show
 */
export var notMoreDataPeople = function () {
    return {
        type: UserActionType.NOT_MORE_DATA_PEOPLE
    };
};
/**
 * Set last page request of profile posts
 */
export var requestPagePeople = function (page) {
    return {
        type: UserActionType.REQUEST_PAGE_PEOPLE,
        payload: { page: page }
    };
};
/**
 * Set last user identification of find people page
 */
export var lastUserPeople = function (lastUserId) {
    return {
        type: UserActionType.LAST_USER_PEOPLE,
        payload: { lastUserId: lastUserId }
    };
};



//////////////////
// WEBPACK FOOTER
// ./src/store/actions/userActions.ts
// module id = 122
// module chunks = 50